import { formatCurrency } from 'syf-js-utilities/formats';
import { paymentOptions } from '../../const/paymentOptions';
import { getLoanProductPaymentAmount, isInstallmentLoan } from '../../helpers';
import { t } from '../../strings/i18n';
import { requiredIf } from '../../xform';
const validateOtherAmount = (accountSummary) => {
    const { credit, product } = accountSummary;
    const { currentBalance } = credit;
    const loanProductPaymentAmount = isInstallmentLoan(product.type) &&
        getLoanProductPaymentAmount(accountSummary);
    return (value, values) => {
        if (value === null || value === undefined || value === '') {
            return;
        }
        // Payment amount only needs to be validated if the user selected other amount
        if (values.paymentOption !== paymentOptions.OTHER_PAYMENT) {
            return;
        }
        if (Number(value) === 0) {
            throw new Error(t('errors.otherAmountZeroError'));
        }
        if (isInstallmentLoan(product.type) &&
            Number(value) < Number(loanProductPaymentAmount)) {
            throw new Error(t('errors.lessThanMonthly', {
                minimumPayment: formatCurrency(loanProductPaymentAmount)
            }));
        }
        if (isInstallmentLoan(product.type) &&
            Number(value) === Number(currentBalance)) {
            throw new Error(t('errors.autopayOtherAmountEqualToPayOff'));
        }
        if (isInstallmentLoan(product.type) &&
            Number(value) > Number(currentBalance)) {
            throw new Error(t('errors.otherAmountGreaterThanLoanBalance', {
                statementBalance: formatCurrency(currentBalance)
            }));
        }
        if (Number(value) > Number(currentBalance)) {
            throw new Error(t('errors.amountGreaterThanCurrentBalance'));
        }
    };
};
const paymentAmountConfig = (apiMachineRef) => {
    const api = apiMachineRef.getSnapshot().context;
    const autopayStatus = api.autopayStatusQueryResult.data;
    const accountSummary = api.accountSummaryQueryResult.data;
    let paymentAmount;
    if (autopayStatus.enrollment === true) {
        paymentAmount = autopayStatus.enrollmentDetails.paymentAmount;
    }
    return [
        'paymentAmount',
        paymentAmount,
        'ENABLED',
        [
            requiredIf(t('errors.otherAmount'), ({ paymentOption }) => paymentOption === 'otherAmountOption'),
            validateOtherAmount(accountSummary)
        ]
    ];
};
export default paymentAmountConfig;
